import { http } from '@uhg-abyss/web/tools/http';
import { event as eapmEvent } from '@uhg-abyss/web/tools/event';
import { getSourceSystem } from '../utility';

const getApiPath = ({ currentFlow, isDental }) => {
  let flowID = currentFlow;

  if (currentFlow.includes('API marketplace')) {
    if (isDental) {
      return `/ext/dental/validateTin/v1`;
    }
    if (currentFlow.includes('provider')) flowID = 'provider';
    if (currentFlow.includes('billing')) flowID = 'billing';
    if (currentFlow.includes('vendor')) flowID = 'vendor';
    return `/ext/${flowID}/validateTin/v1`;
  }
  return currentFlow ? `/${flowID}/validateTin/v1` : '';
};

const getRequestPayload = ({ TINNumber, currentFlow }) => {
  return currentFlow ? { tin: TINNumber } : '';
};

export const validateTIN = async (payload) => {
  const apiPath = getApiPath(payload);
  const apiPayload = getRequestPayload(payload);
  const sourceSystem = getSourceSystem(payload.currentFlow);

  const response = await http({
    method: 'POST',
    cache: false,
    withCredentials: true,
    url: `${payload.url}${apiPath}`,
    headers: {
      sourceSystem,
    },
    handleError: async (err) => {
      const { error } = err.data;
      const { duration, endpoint, message, data, status } = err;
      const errorData = {
        status: data?.error?.code,
        message: data?.error?.description || message,
        code: status,
        duration,
        endpoint,
      };
      eapmEvent('EAPM_TRANSACTION_ERROR', errorData);
      const errObj = {
        error: { ...error, status: err.status },
      };

      return {
        data: {
          ...errObj,
        },
      };
    },
    body: apiPayload,
  });
  const { duration, endpoint, status } = response;

  const successData = {
    endpoint,
    duration,
    status,
    uuid: payload.uuid,
  };
  eapmEvent('EAPM_TRANSACTION_SUCCESS', successData);
  return response.data;
};

export const notifyRCMTin = async (payload) => {
  const response = await http({
    method: 'POST',
    cache: false,
    withCredentials: true,
    url: `${payload.url}/provider/rcmTin/v1`,
    handleError: async (err) => {
      const { error } = err.data;
      const { duration, endpoint, message, data, status } = err;
      const errorData = {
        status: data?.error?.code,
        message: data?.error?.description || message,
        code: status,
        duration,
        endpoint,
      };
      eapmEvent('EAPM_TRANSACTION_ERROR', errorData);
      return {
        data: {
          error: { ...error, status: err.status },
        },
      };
    },
    body: { tin: payload.tin },
  });

  const { duration, endpoint, status } = response;
  eapmEvent('EAPM_TRANSACTION_SUCCESS', { endpoint, duration, status });
  return response.data;
};
